<div class="m-mini-search-result"
     *ngIf="showSearchResult"
     [ngClass]="{'--only-products': !categories.length, '--only-categories': !products.length}"
>
  <div class="m-products"
       *ngIf="products.length"
  >
    <div class="a-products-header">
      {{ 'minisearchbox.products' | translate}}
    </div>

    <a href="{{ product.url }}"
       *ngFor="let product of products"
       class="a-product"
       (click)="forward(product.url)"
    >
      <div class="a-product-img-box"
           *ngIf="product.picture.url"
      >
        <img src="{{product.picture.url}}" alt="{{product.name}}" class="a-product-img" />
      </div>
      <div class="a-product-title">
        {{product.name}} {{product.brandName | uppercase}}{{product.frameColour ? ', ' + product.frameColour : ''}}
      </div>
      <div class="a-product-price">
        {{!!product.discountPrice ? product.discountPrice.formattedValue : product.price.formattedValue}}
      </div>
    </a>
  </div>

  <div class="m-categories"
       *ngIf="categories.length"
  >
    <div class="a-header a-categories-header">
      {{ 'minisearchbox.categories' | translate}}
    </div>
    <a href="{{category.url}}"
       *ngFor="let category of categories"
       class="a-category"
       (click)="forward(category.url)"
    >
      <div class="a-category-title">
        {{category.name}}

        <span class="a-category-quantity">
          ({{category.numberOfProducts}})
        </span>
      </div>

    </a>
  </div>

  <div class="a-footer">
    <div class="engi_section-btn">
      <a href="{{urlToAllResult}}"
         class="a-button"
         (click)="redirectToAllResult()"
      >
        {{ 'minisearchbox.show.all' | translate}}
      </a>
    </div>
  </div>

</div>
